const getDefaultModelPic = () => {
  return "https://firebasestorage.googleapis.com/v0/b/apartmentvr-28fee.appspot.com/o/assets%2Fimg%2FdefaultModelThumbnail.jpg?alt=media&token=0525c187-431a-47e8-8132-84e535296f86";
};

export default getDefaultModelPic;
